import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import theme, { getTheme } from '../theme';
import { useDarkMode } from '../context/DarkModeContext';

// Cailyn — Learnable's AI guide. Purple = intelligence, magic, AI.
export function CailynMark({ size = 28, color = '#8b6fd4', style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, display: 'block', ...style }}>
      <path d="M7 6 8.3 2.5 9.6 6" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.4 6 15.7 2.5 17 6" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="13" r="8" stroke={color} strokeWidth="1.6" />
      <path d="M4.4 14.5C3 16 3 18 4.6 19.4M19.6 14.5C21 16 21 18 19.4 19.4" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="8.7" cy="12.2" r="2.5" stroke={color} strokeWidth="1.4" />
      <circle cx="15.3" cy="12.2" r="2.5" stroke={color} strokeWidth="1.4" />
      <circle cx="8.7" cy="12.4" r="0.9" fill={color} />
      <circle cx="15.3" cy="12.4" r="0.9" fill={color} />
      <path d="M11.2 15.3 12 17.3 12.8 15.3Z" fill={color} />
    </svg>
  );
}

export function CailynAvatar({ size = 36 }) {
  const { isDark } = useDarkMode();
  const t = getTheme(isDark);
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: `linear-gradient(135deg, ${t.purple} 0%, #6b52a8 100%)`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      boxShadow: '0 4px 16px rgba(107,79,165,0.3)',
      flexShrink: 0,
    }}>
      <CailynMark size={Math.round(size * 0.65)} color="white" />
    </div>
  );
}

export function CailynButton({ subjectId }) {
  const navigate = useNavigate();
  const [hover, setHover] = useState(false);
  const { isDark } = useDarkMode();
  const t = getTheme(isDark);
  return (
    <button
      onClick={() => navigate(subjectId ? `/tutor/${subjectId}` : '/tutor')}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-label="Ask Cailyn"
      title="Ask Cailyn"
      style={{
        position: 'fixed', bottom: '24px', right: '24px', zIndex: 150,
        width: '52px', height: '52px', borderRadius: '50%',
        background: `linear-gradient(135deg, ${t.purple} 0%, #6b52a8 100%)`,
        border: 'none',
        boxShadow: hover ? '0 8px 32px rgba(107,79,165,0.45)' : '0 4px 20px rgba(107,79,165,0.3)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer', transition: theme.transition,
        transform: hover ? 'translateY(-3px) scale(1.05)' : 'none',
      }}
    >
      <CailynMark size={26} color="white" />
    </button>
  );
}

export default CailynMark;
